import React from 'react';
import Message from './message';
import {IChatReplyState} from '../type';
import {IIsDeleteChat} from '..';

interface ChatmsgItemProps {
  chat: IMessagesChatsResults;
  currentVideoPlaying?: string;
  guid: string;
  replyingChat?: IChatReplyState;
  userChatDetailData: IGetUserCHatDetailData | undefined;
  isDeleteChat: IIsDeleteChat;
  refresh: () => void;
  setIsDeleteChat: React.Dispatch<React.SetStateAction<IIsDeleteChat>>;
  setcurrentVideoPlaying: React.Dispatch<
    React.SetStateAction<string | undefined>
  >;
  setReplyingChat: React.Dispatch<
    React.SetStateAction<IChatReplyState | undefined>
  >;
  setParentChatGuid: React.Dispatch<React.SetStateAction<string>>;
}
const ChatmsgItem = ({
  chat,
  guid,
  currentVideoPlaying,
  userChatDetailData,
  replyingChat,
  isDeleteChat,
  setcurrentVideoPlaying,
  setIsDeleteChat,
  setReplyingChat,
  refresh,
  setParentChatGuid,
}: ChatmsgItemProps) => {
  return (
    <>
      <Message
        replyingChat={replyingChat}
        chat={chat}
        guid={guid}
        currentVideoPlaying={currentVideoPlaying}
        created_at={chat.created_at}
        is_author={
          String(userChatDetailData?.sender_profile.username) ===
          String(chat.sender)
        }
        text={chat.message}
        is_seen={chat?.is_seen}
        isDeleteChat={isDeleteChat}
        refresh={refresh}
        setIsDeleteChat={setIsDeleteChat}
        setcurrentVideoPlaying={setcurrentVideoPlaying}
        setReplyingChat={setReplyingChat}
        setParentChatGuid={setParentChatGuid}
      />
    </>
  );
};

export default ChatmsgItem;
